import { useEffect } from 'react'

const useDocumentTitle = title =>
  useEffect(() => {
    document.title = `${title ? `${title} - ` : ''}Yellowdig`
  }, [title])

export default useDocumentTitle
